import { isFeatureFlagEnabled } from '@doordash/lib-feature-flags'
import * as H from 'history'
import * as React from 'react'
import * as queryString from 'query-string'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import { UNIQUE_LINK_KEY, EMAIL_KEY } from '../../../constants'
import * as Exp from '../../../experimentConstants'
import routes from '../../../routes'
import SimpleStore, {
  deleteUserSessionToken,
} from '../../../utilities/SimpleStore'
import LoginModal from '../../organisms/login-modal'

type ApplicationProps = {
  loadDasher: () => Promise<any>
  applicantUniqueLink: string
  history: H.History
}

export const Application: React.FC<ApplicationProps> = ({
  loadDasher,
  applicantUniqueLink,
  history,
}) => {
  const [isLoading, setIsLoading] = React.useState<boolean>(true)
  const [isError, setIsError] = React.useState<boolean>(false)
  const [localUniqueLink, setLocalUniqueLink] = React.useState<string>(
    SimpleStore.get(UNIQUE_LINK_KEY)
  )

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        await loadDasher()
      } catch (e) {
        setIsError(true)
      } finally {
        setIsLoading(false)
      }
    }

    /**
     * If applicant unique link is set in local storage, use that
     * This is set in the return to application flow
     */
    if (SimpleStore.get(UNIQUE_LINK_KEY)) {
      setLocalUniqueLink(SimpleStore.get(UNIQUE_LINK_KEY))
    } else {
      fetchData()
    }
  }, [loadDasher])

  if (history && (applicantUniqueLink || localUniqueLink)) {
    // If we don't have the unique link set in localStorage yet, set it
    if (!localUniqueLink) {
      SimpleStore.set(UNIQUE_LINK_KEY, applicantUniqueLink)
    }

    window.location.assign(
      routes.application.path + (applicantUniqueLink || localUniqueLink)
    )
    return <React.Fragment />
  }

  if (isError) {
    // This case may be encountered when the user directly
    // hits /dasher/application and logs in with an account that
    // does not yet have a Dasher associated with it. In this case,
    // clear their cookies and redirect them to the landing page.
    // They will have to use the return to application feature
    // manually for now.
    deleteUserSessionToken()
    window.location.assign(routes.dasherSignup.path)
    return <React.Fragment />
  }

  // If IDS experiment enabled, take user to IDS login webview
  // Otherwise use legacy Login Modal
  if (
    !isLoading &&
    applicantUniqueLink == null &&
    isFeatureFlagEnabled(Exp.DASHER_WEB_IDENTITY_SERVICE_MIGRATION)
  ) {
    if (isFeatureFlagEnabled(Exp.IDENTITY_LOGIN_BANNER)) {
      const params = queryString.stringify({
        email: SimpleStore.get(EMAIL_KEY),
        cxLoginBanner: true,
      })
      window.location.assign(`${routes.login.path}?${params}`)
    } else {
      window.location.assign(routes.login.path)
    }

    return <React.Fragment />
  }

  return <LoginModal shouldHideDescription />
}
const mapStateToProps = state => ({
  applicantUniqueLink: state.applicantUniqueLink,
})

const mapDispatchToProps = {
  loadDasher: actions.loadDasher,
}

export default connect(mapStateToProps, mapDispatchToProps)(Application)
